import { render, staticRenderFns } from "./app_05_office_stationery.vue?vue&type=template&id=0108054b&lang=pug&"
import script from "./app_05_office_stationery.vue?vue&type=script&lang=js&"
export * from "./app_05_office_stationery.vue?vue&type=script&lang=js&"
import style0 from "./app_05_office_stationery.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports